export default __webpack_public_path__ + "static/media/img_2.cc310a53.JPG";